<template>
    <div class="wrapper">
        <div class="head flex ai-c">
            <logo :Index="Index" />
        </div>
        <ripple :Index="Index" />
        <star :Index="Index"  />
        <txt :Index="Index"  />
        <stairs :Index="Index"  />
        <div class="wans flex fd-c">
            <W :Index="Index" />
            <A :Index="Index" />
            <N :Index="Index" />
            <S  :Index="Index" />
        </div>
    </div>
</template>

<script>
import logo from "./logo.vue";
import star from "./star.vue";
import ripple from "./ripple.vue";
import W from "./W.vue";
import A from "./A.vue";
import N from "./N.vue";
import S from "./S.vue";
import txt from "./txt.vue";
import stairs from "./stairs.vue";
import wx from 'weixin-js-sdk'
export default {
    components: {
        logo,
        ripple,
        star,
        W,
        A,
        N,
        S,
        txt,
        stairs,
    },
    props: {},
    data() {
        return {
            timer: null,
            Index: 0,
        };
    },
    watch: {},
    computed: {},
    methods: {},
    created() {
        this.timer = setInterval(() => {
            this.Index++;
        }, 50);
    },
    mounted() {
        wx.ready(() => {
            var obj = {
                title: 'WANS｜品牌互动营销案例精选', // 分享标题
                desc: '历史不可复制，破局者得以生存', // 分享描述
                link: 'https://case.chinawans.com/#/home', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://case.chinawans.com/img/share.jpg', // 分享图标
                success: function () {
                // 设置成功
                }
            }
            // wx.hideOptionMenu();
            wx.updateAppMessageShareData(obj)
            wx.updateTimelineShareData(obj)
        })
    },
    destroyed() {
        clearInterval(this.timer);
    },
};
</script>
<style scoped>
.wrapper {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url(../../assets/images/bg.png);
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-color: rgba(29, 29, 29, 1);
}
.head {
    position: relative;
    z-index: 10;
    width: 100%;
    height: 1.29rem;
    background-color: #343434;
}
.wans{
    position: absolute;
    right: 0.2rem;
    top: 2.3rem;
    width: 1rem;
    /* height: 3rem; */
    z-index: 51;
}
</style>